let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aWnGM")).then(() => parcelRequire('43bOU'));